import React, { useState } from 'react';
import { useSeenStatus } from '@atlassian/jira-servicedesk-itsm-onboarding-common/src/controllers/seen-status/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/outlet/index.tsx';
import {
	JSM_PROJECT_SUMMARY_BOARDING_SEEN_STATUS,
	PACKAGE_NAME,
	TEAM_NAME,
} from '../../../common/constants.tsx';
import { useProjectSummaryFeatureStatus } from '../../../ops/project-summary-onboarding/index.tsx';
import ProjectSummaryOnboardingWithChoreograph from './onboarding/index.tsx';

type ProjectSummaryOnboardingProps = {
	projectKey: string;
};

const ProjectSummaryOnboarding = ({ projectKey }: ProjectSummaryOnboardingProps) => {
	const { data: projectContextData } = useProjectContext();
	const isProjectAdmin = projectContextData?.isProjectAdmin ?? false;
	const [isOpen, setIsOpen] = useState(true);
	const [
		{ isSeen: hasSeenProjectSummaryOnboarding },
		{ markAsSeen: markAsSeenProjectSummaryOnboarding },
	] = useSeenStatus({
		userPropertyKey: `${JSM_PROJECT_SUMMARY_BOARDING_SEEN_STATUS}-${projectKey}`,
		isSeenValue: true,
		packageName: PACKAGE_NAME,
		teamName: TEAM_NAME,
	});
	const hasFeatureBeenToggled = useProjectSummaryFeatureStatus(projectKey);

	if (!isProjectAdmin || hasSeenProjectSummaryOnboarding || hasFeatureBeenToggled) {
		return null;
	}

	return (
		isOpen && (
			<ProjectSummaryOnboardingWithChoreograph
				projectKey={projectKey}
				setIsOpen={setIsOpen}
				onMarkProjectSummaryOnboardingAsSeen={markAsSeenProjectSummaryOnboarding}
				messageId="servicedesk-queues-agent-view.layout.project-summary-onboarding.project-summary-onboarding-with-choreograph.choreographer-spotlight-card-with-image.jsm-project-summary-onboarding"
			/>
		)
	);
};

export const ProjectSummaryOnboardingWithErrorBoundary = ({
	projectKey,
}: ProjectSummaryOnboardingProps) => {
	return (
		<JiraBottomRightCornerOutlet
			orderFromRight={5}
			id="servicedesk-project-summary-onboarding-outlet"
		>
			<JSErrorBoundary
				id="servicedesk-project-summary-onboarding"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
				fallback="unmount"
			>
				<ProjectSummaryOnboarding projectKey={projectKey} />
			</JSErrorBoundary>
		</JiraBottomRightCornerOutlet>
	);
};

export default ProjectSummaryOnboardingWithErrorBoundary;
